/**
 * KairosLogo — SVG monogram mark for the Kairos app.
 *
 * Design: A serif-inspired K letterform inscribed in a thin circle.
 * The circle represents the fullness of time (πλήρωμα χρόνου),
 * and the K refers to Kairos — God's appointed moment breaking into history.
 *
 * Usage:
 *   <KairosLogo />                   — default 36 px, inherits color
 *   <KairosLogo size={48} />         — custom size
 *   <KairosLogo color="#6a7662" />   — explicit colour
 */
export default function KairosLogo({ size = 36, color = 'currentColor', className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label="Kairos"
      role="img"
    >
      {/* Outer circle — the fullness of time */}
      <circle cx="20" cy="20" r="17" strokeWidth="1.4" />

      {/* Vertical stem of the K */}
      <line x1="14" y1="7.5" x2="14" y2="32.5" strokeWidth="2.1" />

      {/* Upper arm of the K — sweeping from midpoint to upper right */}
      <path d="M14,20 Q18,15 25.5,8" strokeWidth="2.1" fill="none" />

      {/* Lower arm of the K — sweeping from midpoint to lower right */}
      <path d="M14,20 Q18,25 25.5,32" strokeWidth="2.1" fill="none" />
    </svg>
  );
}
